import { User as KaizenIdUser } from '@kaizenplatform/kaizen-id-entity';

import Language from './Language';
import TimeZone, { AVAILABLE_TIMEZONE_NAMES } from './TimeZone';

export enum Provider {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
}

export const EMAIL_MAX_LENGTH = 256;
export const PASSWORD_MAX_LENGTH = 256;
export const USERNAME_MAX_LENGH = 60;

class User extends KaizenIdUser {
  public readonly email?: string;
  public readonly allowPublicSearch: boolean | null;
  public readonly allowPublicProfile: boolean | null;
  public readonly receivingEmails: boolean | null;
  public readonly comment: string | null;
  public readonly hasPassword?: boolean;
  public readonly providers?: Provider[];
  public readonly lang: Language | null;
  public readonly timeZone: TimeZone | null;
  public readonly unconfirmedEmail?: string;
  public readonly otpEnabled?: boolean;
  public readonly useUsFlow?: boolean;
  public readonly doneUrl?: string;

  constructor({
    id,
    name,
    profileImageUrl,
    email,
    hasPassword,
    providers,
    allowPublicProfile,
    allowPublicSearch,
    receivingEmails,
    comment,
    lang,
    timeZone,
    unconfirmedEmail,
    otpEnabled,
    useUsFlow,
    doneUrl,
  }: Pick<KaizenIdUser, 'id' | 'name' | 'profileImageUrl'> & {
    email?: string;
    hasPassword?: boolean;
    providers?: Provider[];
    allowPublicProfile: boolean;
    allowPublicSearch: boolean;
    receivingEmails: boolean;
    comment: string;
    lang: Language;
    timeZone: TimeZone;
    unconfirmedEmail?: string;
    otpEnabled?: boolean;
    useUsFlow?: boolean;
    doneUrl?: string;
  }) {
    super({ id, name, profileImageUrl });
    this.email = email;
    this.hasPassword = hasPassword;
    this.providers = providers;
    this.allowPublicProfile = allowPublicProfile;
    this.allowPublicSearch = allowPublicSearch;
    this.receivingEmails = receivingEmails;
    this.comment = comment;
    this.lang = lang;
    this.timeZone = timeZone;
    this.unconfirmedEmail = unconfirmedEmail;
    this.otpEnabled = otpEnabled;
    this.useUsFlow = useUsFlow;
    this.doneUrl = doneUrl;
  }

  public static fromJSON = (value: any) => {
    const {
      id,
      name,
      profileImageUrl,
      email,
      hasPassword,
      providers,
      allowPublicProfile,
      allowPublicSearch,
      receivingEmails,
      comment,
      lang,
      timeZone,
      unconfirmedEmail,
      otpEnabled,
      useUsFlow,
      doneUrl,
    } = Object.assign({}, value);

    // TODO これはid-entityに持っていく
    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (profileImageUrl && typeof profileImageUrl !== 'string')
      throw new TypeError('.profileImageUrl must be a string');
    if (timeZone && !AVAILABLE_TIMEZONE_NAMES.includes(timeZone))
      throw new TypeError('.timeZone must be a valid timeZone string');

    return new User({
      id,
      name,
      profileImageUrl,
      email,
      hasPassword,
      providers,
      allowPublicProfile,
      allowPublicSearch,
      receivingEmails,
      comment,
      lang,
      timeZone,
      unconfirmedEmail,
      otpEnabled,
      useUsFlow,
      doneUrl,
    });
  };
}

export default User;
